import {FETCH_TERMS} from "./actions";
import {Term} from "./types";

const initialState: Term[] = [];

export function termsReducer(
    state = initialState,
    action: any
): Term[] {
    switch (action.type) {
        case FETCH_TERMS: {
            return action.payload;
        }
        default:
            return state
    }
}
